<template>
  <div class="thin-scroll">
    <template v-if="displayTitle">
      <base-card-title expanded>
        {{ displayTitle ? $t('inventory.title') : '\xa0' }}
      </base-card-title>
    </template>
    <div v-if="selectedMainFacetValueId" class="catalog_sortby" :style="`${!showFilterChips && responsive.lg || hideFilterChips ? 'justify-content: end; margin-bottom: 12px' :'justify-content: space-between'}`">
      <template>
        <base-transition-expand speed="fast">
          <div v-if="showFilterChips || (!responsive.lg && showFilterButton)" class="d-inline-flex align-center">
            <base-button
              v-if="!responsive.lg && showFilterButton "
              small
              text
              class="catalog-product-list__filter-btn"
              style="justify-content: start"
              @click="$emit('toggle-filter-drawer')"
            >
              <base-icon icon="filter" class="mr-1" />Filter
            </base-button>
            <div v-if="showFilterChips && responsive.lg && showFilterTags" style="margin-left: 3px;">
              <div class="catalog-product-list__filter">
                <span class="filter_count">
                  {{ numResults }} results
                </span>
                <div>
                  <template v-for="(filter, index) in filtersLimited">
                    <slot name="filters" :index="index" :filter="filter">
                      <base-chip
                        :key="index" :label="filter"
                        @delete="$emit('delete', filter)"
                      />
                    </slot>
                  </template>
                  <div class="catalog-product-list__clear-btn" @click="$emit('clear')">
                    Clear all
                  </div>
                </div>
              </div>
            </div>
          </div>
        </base-transition-expand>
      </template>
      <div
        :class="`${!showFilterChips ? 'ml-auto' : ''}`"
        style="align-items: flex-start; display: inline-flex; justify-content: end; position: relative;"
      >
        <!-- search -->
        <transition name="fade">
          <div class="search-wrapper">
            <base-search
              icon-position="left"
              :value="search"
              class="search_button"
              has-cancel-search="true"
              :focus-on-mount="false"
              @input="onSearch"
              @cancelSearch="cancelSearch"
            />
          </div>
        </transition>

        <div v-show="canViewRegionsSelector" class="inventory-switcher-outer-wrapper">
          <img
            src="/img/icon-globe.svg"
            width="24"
            height="24"
            alt
            @click="toggleInventorySwitcher"
          >
          <div v-if="showInventorySwitcher" class="inventory-switcher-inner-wrapper">
            <regions-dropdown-select
              label="Please select"
              :items="regionsForSelectInput"
              :value="selectedRegion"
              :min-width="180"
              :force-open="showInventorySwitcher"
              :hide-top="showInventorySwitcher"
              @input="onRegionSelect($event)"
            />
          </div>
        </div>

        <slot name="right" />
      </div>
    </div>
    <div
      v-if="selectedMainFacetValueId"
      v-scrollable="{
        heightThresholdAdjust: 20,
        noPixel: true,
      }"
      :class="{ 'catalog-product-list__grid--scrollable': scrollable,
                'popup': caller === 'catalog-product-selector',
                'catalog-product-list__grid--small-columns': !responsive.lg && !showFilterButton,
                'catalog-product-list__grid' : (items.length >= 1),
                'search-notfound' : items.length === 0
      }"
      @reached-bottom="$emit('reached-bottom')"
    >
      <div v-if="items.length === 0 && !loading" class="no_matches">
        <div>
          <base-icon
            icon="icon-product"
            style="margin: 50% 20px 20px 30%; width: 56px;height: 56px;"
          />
          <br>
          <span style="font-family: 'SilkaLight'">
            No products available
          </span>
        </div>
      </div>
      <template v-else>
        <slot v-for="(item, index) in items" :index="index" :item="item" />
      </template>
    </div>
    <div v-else-if="!facetLoading" class="select-facet">
      <div class="select-facet__top-section">
        <div v-show="canViewRegionsSelector" class="select-facet__inventory-switcher-outer-wrapper">
          <img
            src="/img/icon-globe.svg"
            width="24"
            height="24"
            alt
            @click="toggleInventorySwitcher"
          >
          <div v-if="showInventorySwitcher" class="inventory-switcher-inner-wrapper">
            <regions-dropdown-select
              label="Please select"
              :items="regionsForSelectInput"
              :value="selectedRegion"
              :min-width="180"
              :force-open="showInventorySwitcher"
              :hide-top="showInventorySwitcher"
              @input="onRegionSelect($event)"
            />
          </div>
        </div>
        <div class="slot-disabled">
          <slot name="right" />
        </div>
      </div>
      <p class="select-facet__title">
        Select Department
      </p>
      <p class="select-facet__subtitle">
        Please select a department from the inventory options below:
      </p>
      <span class="select-facet__button-container">
        <button
          v-for="(item, index) in facetValuesArray" :key="index" class="select-facet__button"
          @click="selectDepartment(item)"
        >
          {{ mapWear(item.name) }}
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import responsive from '@/components/mixins/responsive';
import { EventBus } from '@/event-bus';
import _ from 'lodash';
import RegionsDropdownSelect from '@/components/RegionsDropdownSelect';

export default {
  name: 'CatalogProductList',
  components: { RegionsDropdownSelect },
  mixins: [responsive],
  props: {
    displayTitle: {
      type: Boolean,
      default: true,
    },
    scrollable: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Array,
      default: () => [],
    },
    filtersLimit: {
      type: Number,
      default: 10,
    },
    showFilterButton: {
      type: Boolean,
      default: false,
    },
    hideFilterChips: {
      type: Boolean,
      default: false,
    },
    caller: {
      type: String,
      default: null,
    },
    search: {
      type: String,
      default: '',
    },
    numResults: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    showSearch: false,
    showInventorySwitcher: false,
    showFilterTags: true,
    isSorted: '',
    didUserSelectRegion: false,
  }),
  computed: {
    filtersLimited() {
      return this.filters;
    },
    showFilterChips() {
      return this.filters.length > 0;
    },
    selectedFacets() {
      return this.$store.getters['catalog/selectedFacets'];
    },
    selectedMainFacetValueId() {
      return this.$store.getters['catalog/selectedMainFacetValueId'];
    },
    facetLoading() {
      return this.$store.getters['catalog/facetLoading'];
    },
    computedMainFacets() {
      return this.$store.getters['catalog/facets'];
    },
    selectedFacetsName() {
      return this.$store.state.catalog.selectedFacetsName;
    },
    facetValuesArray() {
      const mainFacetWithValues = this.$store.getters['catalog/mainFacetWithValues'];
      return mainFacetWithValues && mainFacetWithValues.facet_values.length
        ? mainFacetWithValues.facet_values
        : [];
    },
    canViewRegionsSelector() {
      return this.$store.state.account.user.profile.ui.show_regions;
    },
    regions() {
      const hasRegionsFeature = this.$store.state.account.user.profile.ui?.show_regions ?? false;
      if (!hasRegionsFeature) {
        return [];
      }
      return this.$store.state.account.user.profile.institution?.regions ?? [];
    },
    regionsForSelectInput() {
      return this.regions.map((region) => region.title);
    },
    defaultRegionIdentifier() {
      const firstRegionInList = this.regions.length ? this.regions[0] : null;
      const region = this.userProfileDefaultRegion ?? this.institutionDefaultRegion ?? firstRegionInList ?? null;
      return this.regions.find((regionObject) => regionObject.pk === region)?.identifier ?? null;
    },
    userProfileDefaultRegion() {
      return this.$store.state.account.user.profile?.default_region ?? null;
    },
    institutionDefaultRegion() {
      return this.$store.state.account.user.profile?.institution?.default_region_id ?? null;
    },
    selectedRegion() {
      const regionIds = this.regions.map((region) => region.identifier);
      const regionIdentifier = this.$store.getters['catalog/regionIdentifier'];
      const currentRegionObject = this.regions.find((region) => region.identifier === regionIdentifier);
      const regionIdentifierOrDefault = currentRegionObject?.identifier ?? this.defaultRegionIdentifier;
      const currentIndex = regionIds.indexOf(regionIdentifierOrDefault);

      return currentIndex;
    },
  },
  watch: {
    loading: {
      immediate: true,
      handler() {
        this.showInventorySwitcher = false;
      },
    },
  },
  mounted() {
    EventBus.$on('isSort', (val) => {
      this.isSorted = val;
    });
  },
  methods: {
    onSearch: _.debounce(($event) => {
      EventBus.$emit('searchFilterProduct', $event);
    }, 300),
    btnSearch() {
      this.showFilterTags = false;
      this.showSearch = true;
    },
    cancelSearch() {
      this.showFilterTags = false;
      this.showSearch = false;
      this.hideFilterChips = false;
      this.showFilterTags = true;
      EventBus.$emit('searchFilterProduct', '');
    },
    toggleInventorySwitcher() {
      this.showInventorySwitcher = !this.showInventorySwitcher;
    },
    mapWear(item) {
      if (item === 'MENSWEAR') return 'MENS';
      else if (item === 'WOMENSWEAR') return 'WOMENS';
      return item;
    },
    async selectDepartment(filter) {
      if (this.canViewRegionsSelector && this.regions && this.regions.length && !this.didUserSelectRegion) {
        this.$store.dispatch('catalog/setRegionIdentifier', this.regions[this.selectedRegion].identifier || this.defaultRegionIdentifier);
      }

      await this.$store.dispatch('catalog/setSelectedMainFacetValueId', filter.id);

      if (this.selectedMainFacetValueId) {
        const obj = {};
        for (let item = 0; item < this.selectedFacets.length; item += 1) {
          const facetValueId = this.selectedFacets[item];
          const facetName = this.selectedFacetsName[item].facet_name;
          if (!(facetName in obj)) {
            obj[facetName] = [facetValueId];
          } else {
            obj[facetName].push(facetValueId);
          }
        }
        Object.entries(obj).forEach(([k, v]) => {
          try {
            obj[k] = v.join(',');
          } catch (e) {
            console.log(e);
          }
        });

        obj[filter.facet_name] = filter.id;
        this.$store.dispatch('catalog/fetchFacets', { specialHandling: false, additionalParams: obj });
      } else {
        this.$store.dispatch('catalog/fetchFacets', {});
      }
    },
    onRegionSelect(selectedIndex) {
      const region = typeof this.regions[selectedIndex] !== 'undefined' ? this.regions[selectedIndex] : null;
      if (!region) {
        return;
      }
      this.didUserSelectRegion = true;
      this.$store.dispatch('catalog/setRegionIdentifier', region.identifier);
      this.showInventorySwitcher = false;
    },
  },

};
</script>

<style lang="scss" scoped>
.catalog-product-list {
  &__filter {
    display: flex;
    margin-bottom: 20px;
    margin-left: -3px; // Equal to base-chip margin-left
    margin-right: -3px; // Equal to base-chip margin-right
  }
  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-gap: 16px;

    &--scrollable {
      padding: 2px; // Compensate for shadow
      overflow-y: auto;
      max-height: calc(100vh - 240px);
      &.popup {
        //  max-height: 65vh;
         max-height: 442px;
      }
    }

    &--small-columns {
      grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    }
  }

  &__clear-btn {
    border: none !important;
    background: none !important;
    font-family: 'SilkaLight';
    font-size: $font-size-s;
    padding: 3px 5px 0px 5px;
    height: 20px;
    display: inline-flex;
    min-width: 65px;
    cursor: pointer;
    color: #333333;
    vertical-align: top;

    &:hover{
      color: #282828 !important;
    }
  }
  &__filter-btn {
    margin-bottom: 20px;
    margin-right: 30px;
    margin-left: 0;
    padding-left: 0;
  }
}
.base-card-title__text {
    font-family: $font-family-timepos-headline;
    font-weight: 700;
    color: $black;
}
.catalog_sortby {
  justify-content: space-between !important;
  display: flex;
}
::v-deep .base-chip {
  border: 1px solid #C6C6C6;
  box-shadow: unset;
  border-radius: 4px;
  height: 20px;
}
.filter_count {
  margin-bottom: 8px;
  min-width: 50px;
  font-family: 'SilkaLight';
  font-size: 12px;
  color: #767676;
}
::v-deep .base-button {
  align-items: revert;
}
::v-deep .base-button--small {
  padding: 5px 5px 0px 0px;
}
::v-deep .base-icon {
  width: 14px;
}
::v-deep .base-dropdown__icon {
  width: 10px !important;
}
::v-deep .base-chip {
  margin: 0px 5px 8px 5px !important;
}
.search_button {
  margin-bottom: 13px;
  margin-top: -5px;
  width: 100%;
  margin-right: 11px;
  border-radius: 5px;
}
.no_matches {
  display: flex;
  justify-content: center;
  margin-top: 10%;
}
.search-notfound{
  background-color: #FAF9F7;
  height: 626px;
}
.action-close{
  right: 0%;
  margin-top: 5px;
  margin-right: 85px;
  cursor: pointer;
}
.action-close-sort{
  right: 3%;
  margin-right: unset;
}

.select-facet{
  height: 50vh;
  position: relative;

  &__title{
    font-weight: 500;
    font-size: 16px;
    padding-top: 20px;
    font-family: "SilkaMedium"
  }
  &__subtitle{
    font-weight: 300;
    font-size: 14px;
    font-family: $font-family-sans-serif-light
  }
  &__button{
    border-radius:4px;
    border: 1px #E2E2E2 solid;
    padding: 16px 10px 16px 10px;
    background-color : white;
    margin: 0 24px 0 0;
    font-weight: 300;
    color: #1B1B1B;
    width: 200px;
    font-size: 14px;
    font-family: $font-family-sans-serif-light;
  }
  &__button-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: row;
    margin-top: 20px;
  }

}
.skeleton{
    display: block;
    &__search{
      min-width : 20%;
      max-width: 20%;
      min-height:40px;
    }
    &__first{
      min-width : 20%;
      max-width: 20%;
      height: 12.25px;
      margin: 0 24px 0 0;
      background-color: #e2e2e2;
      display:block;
    }
    &__second{
      min-width : 50%;
      max-width: 50%;
      display:block;
      margin: 0 24px 0 0;
      height:11px;
      background-color: #e2e2e2;
      display:block;
    }
    &__filter{
      float:right;
      width:25%;
      background-color: #e2e2e2;
      display:block;
      height:36px;
    }
    &__block{

    min-height: 20px;
    height:20px;
    background-color: #e2e2e2;
    display:block;

  }
  &__row{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: row;
    margin-top: 20px;
  }
  &__button{
    margin: 0 24px 0 0;
    min-width: 200px;
    max-width: 200px;
    height:40px;
    background-color: #e2e2e2;
    display:block;
  }
  }
  .spacer{
    height: 70px;
    display:block;
  }
  .region-selection-wrapper {
    margin-bottom: 31px;

    &__title {
      display: block;
      font-family: 'SilkaMedium';
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 8px;
      margin-top: 52px;
    }

    &__instructions {
      font-family: 'SilkaLight';
      font-size: 14px;
      margin-bottom: 16px;
    }
  }
  .region-selection {
    width: 150px;
    height: 36px;
  }
  .search-wrapper {
    width: auto;
    position: relative;
    margin-right: 10px;
  }
  .inventory-switcher-outer-wrapper {
    position: relative;
    z-index: 10;
    margin-right: 16px;
    cursor: pointer;
  }
  .inventory-switcher-inner-wrapper {
    width: auto;
    background: #ffffff;
    box-shadow: 0px 12px 12px -6px #33333329;
    position: absolute;
    right: 0;
  }
  .select-facet {
    &__inventory-switcher-outer-wrapper {
      margin-right: 16px;
      z-index: 10;
      position: relative;
      cursor: pointer;
    }
    &__top-section {
      display: flex;
      flex-flow: row;
      width: 100%;
      justify-content: flex-end;
    }
  }
  .slot-disabled {
    opacity: 0.5;
    pointer-events: none;
  }
</style>
